import React from "react";
import CaixaLogo from "./CaixaLogo";
import { LogOut, UserRound } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const AppHeader = ({ rightExtra }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate("/");
  };
  const handleLogoClick = () => {
    if (user) {
      navigate(user.role === "admin" ? "/admin" : "/dashboard");
    } else {
      navigate("/");
    }
  };
  return (
    <header className="bg-white border-b border-slate-200">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <button type="button" onClick={handleLogoClick} className="flex items-center shrink-0 bg-transparent border-0 p-0 cursor-pointer">
          <CaixaLogo size={40} />
        </button>
        <div className="flex items-center gap-2 sm:gap-3">
          {rightExtra}
          {user && (
            <div className="hidden md:flex items-center gap-2 px-3 py-1.5 bg-slate-50 border border-slate-200">
              <UserRound className="w-4 h-4 text-[#007EAE]" />
              <span className="text-sm text-slate-700">
                {user.first_name || user.email}
                <span className="ml-2 text-[11px] uppercase tracking-wide bg-[#007EAE] text-white px-1.5 py-0.5">
                  {user.role}
                </span>
              </span>
            </div>
          )}
          <button
            onClick={handleLogout}
            className="inline-flex items-center gap-1.5 px-3 py-2 bg-[#007EAE] hover:bg-[#006c97] text-white text-sm font-semibold btn-press"
          >
            <LogOut className="w-4 h-4" /> <span className="hidden sm:inline">Déconnexion</span>
          </button>
        </div>
      </div>
      <div className="h-1 bg-[#007EAE]" />
    </header>
  );
};

export default AppHeader;
